module.exports = __webpack_public_path__ + "media/images/front/icons_sp-257ea2a7d7aeaf494fd119e3b449d1ce.png";